module.exports = __webpack_public_path__ + "img/no_calls_icon.73765704.svg";